export default __webpack_public_path__ + "static/media/GridInactive.ea78b085.svg";